import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import { Search as SearchIcon } from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import colors from '../theme/colors.js';
import fonts from '../theme/fonts.js';
import { useTheme } from '@mui/system';
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const SearchBar = ({
  onBlur,
  search,
  onChange,
  customStyle,
  placeholder,
  value,
  iconColor,
  id,
  testid
}) => {
  const [query, setQuery] = useState(value || "");
  const theme = useTheme();

  /**
   * 
   * @param {*} event 
   */
  const _onChangeWithStop = event => {
    event.stopPropagation();
    if (event.key === 'Enter') {
      search(event.target.value);
    }
  };

  /**
   * 
   * @param {*} event 
   */
  const _onChange = event => {
    setQuery(event.target.value);
    onChange && onChange(event);
  };
  return /*#__PURE__*/React.createElement(TextField, {
    id: id || testid,
    variant: "outlined",
    value: query,
    label: placeholder || i18n.t(tokens.labels.search),
    sx: {
      '& .MuiOutlinedInput-root': {
        "&:hover fieldset": {
          borderColor: theme.palette.custom.textFieldHover
        }
      },
      '& .MuiInputBase-root': {
        fontFamily: '"AvenirLTPro-Book", sans-serif',
        fontWeight: 400,
        color: theme.palette.default.contrastText,
        // this keeps letter spacing consistent with site before mui5 upgrade
        letterSpacing: "0.14994px"
      },
      ...customStyle
    },
    InputLabelProps: {
      style: {
        fontFamily: fonts.type.light,
        paddingRight: "2px",
        color: theme.primary
      }
    },
    onBlur: onBlur,
    onChange: _onChange,
    onKeyDown: _onChangeWithStop,
    onFocus: e => e.target.select(),
    type: "text",
    InputProps: {
      autoComplete: 'off',
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: () => search(query),
        "aria-label": "Search",
        sx: {
          padding: "12px",
          "&:hover": {
            backgroundColor: colors.hoverGrey
          },
          color: colors.black
        }
      }, /*#__PURE__*/React.createElement(SearchIcon, {
        style: {
          color: iconColor || null
        }
      })))
    }
  });
};
SearchBar.propTypes = {
  classes: PropTypes.object
};
export default SearchBar;